import React, { useState } from 'react';
import { Calendar, Clock, User, Mail, Phone, MessageSquare, CheckCircle2 } from 'lucide-react';
import { siteData } from '../data/mock';
import SEO from '../components/SEO';

const RendezVousPage = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    consultationType: '',
    preferredDate: '',
    preferredTime: '',
    message: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
    
    // Reset after 3 seconds
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        consultationType: '',
        preferredDate: '',
        preferredTime: '',
        message: ''
      });
    }, 3000);
  };

  return (
    <div style={{ marginTop: '100px' }}>
      <SEO
        title="Prendre rendez-vous — Nutri Centre Riviera Vevey & Clarens"
        description="Réservez en ligne votre consultation au Nutri Centre Riviera. Disponibilités à Vevey et Clarens (Montreux). Première séance découverte de 15 minutes offerte."
        keywords="prendre rendez-vous nutritionniste Vevey, réserver consultation Clarens, séance découverte Montreux, rendez-vous en ligne Riviera"
        url="https://nutricentreriviera.ch/rendez-vous"
      />
      {/* Hero Section */}
      <section style={{
        background: 'var(--gradient-hero)',
        padding: '6rem 0 4rem',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 className="heading-hero" style={{ marginBottom: '1.5rem' }}>
            {siteData.cta.primary}
          </h1>
          <p className="heading-subtitle" style={{ maxWidth: '700px', margin: '0 auto' }}>
            {siteData.appointmentSection.description}
          </p>
          <p className="caption" style={{ 
            marginTop: '1rem', 
            color: 'var(--accent-primary)',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            <CheckCircle2 size={16} />
            {siteData.cta.subtext}
          </p>
        </div>
      </section>

      {/* Form Section */}
      <section className="section-lg" style={{ background: 'white' }}>
        <div className="container" style={{ maxWidth: '900px' }}>
          <div style={{
            background: 'var(--bg-page)',
            borderRadius: '1rem',
            padding: '3rem',
            border: '1px solid var(--border-light)'
          }}>
            {!isSubmitted ? (
              <form onSubmit={handleSubmit}>
                {/* Personal Info */}
                <div style={{ marginBottom: '2rem' }}>
                  <h3 className="heading-3" style={{ marginBottom: '1.5rem' }}>
                    Informations personnelles
                  </h3>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                    gap: '1.5rem'
                  }}>
                    <div>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        marginBottom: '0.5rem',
                        fontSize: '0.95rem',
                        fontWeight: 500,
                        color: 'var(--text-primary)'
                      }}>
                        <User size={18} />
                        Prénom *
                      </label>
                      <input
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                        style={{
                          width: '100%',
                          padding: '0.875rem 1rem',
                          border: '1px solid var(--border-input)',
                          borderRadius: '0.5rem',
                          fontSize: '1rem',
                          transition: 'all 0.2s ease',
                          background: 'white'
                        }}
                        onFocus={(e) => e.target.style.borderColor = 'var(--border-input-focus)'}
                        onBlur={(e) => e.target.style.borderColor = 'var(--border-input)'}
                      />
                    </div>

                    <div>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        marginBottom: '0.5rem',
                        fontSize: '0.95rem',
                        fontWeight: 500,
                        color: 'var(--text-primary)'
                      }}>
                        <User size={18} />
                        Nom *
                      </label>
                      <input
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        required
                        style={{
                          width: '100%',
                          padding: '0.875rem 1rem',
                          border: '1px solid var(--border-input)',
                          borderRadius: '0.5rem',
                          fontSize: '1rem',
                          transition: 'all 0.2s ease',
                          background: 'white'
                        }}
                        onFocus={(e) => e.target.style.borderColor = 'var(--border-input-focus)'}
                        onBlur={(e) => e.target.style.borderColor = 'var(--border-input)'}
                      />
                    </div>

                    <div>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        marginBottom: '0.5rem',
                        fontSize: '0.95rem',
                        fontWeight: 500,
                        color: 'var(--text-primary)'
                      }}>
                        <Mail size={18} />
                        Email *
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        style={{
                          width: '100%',
                          padding: '0.875rem 1rem',
                          border: '1px solid var(--border-input)',
                          borderRadius: '0.5rem',
                          fontSize: '1rem',
                          transition: 'all 0.2s ease',
                          background: 'white'
                        }}
                        onFocus={(e) => e.target.style.borderColor = 'var(--border-input-focus)'}
                        onBlur={(e) => e.target.style.borderColor = 'var(--border-input)'}
                      />
                    </div>

                    <div>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        marginBottom: '0.5rem',
                        fontSize: '0.95rem',
                        fontWeight: 500,
                        color: 'var(--text-primary)'
                      }}>
                        <Phone size={18} />
                        Téléphone *
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        style={{
                          width: '100%',
                          padding: '0.875rem 1rem',
                          border: '1px solid var(--border-input)',
                          borderRadius: '0.5rem',
                          fontSize: '1rem',
                          transition: 'all 0.2s ease',
                          background: 'white'
                        }}
                        onFocus={(e) => e.target.style.borderColor = 'var(--border-input-focus)'}
                        onBlur={(e) => e.target.style.borderColor = 'var(--border-input)'}
                      />
                    </div>
                  </div>
                </div>

                {/* Appointment Details */}
                <div style={{ marginBottom: '2rem' }}>
                  <h3 className="heading-3" style={{ marginBottom: '1.5rem' }}>
                    Détails du rendez-vous
                  </h3>
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                    gap: '1.5rem'
                  }}>
                    <div style={{ gridColumn: '1 / -1' }}>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        marginBottom: '0.5rem',
                        fontSize: '0.95rem',
                        fontWeight: 500,
                        color: 'var(--text-primary)'
                      }}>
                        <MessageSquare size={18} />
                        Type de consultation *
                      </label>
                      <select
                        name="consultationType"
                        value={formData.consultationType}
                        onChange={handleChange}
                        required
                        style={{
                          width: '100%',
                          padding: '0.875rem 1rem',
                          border: '1px solid var(--border-input)',
                          borderRadius: '0.5rem',
                          fontSize: '1rem',
                          transition: 'all 0.2s ease',
                          background: 'white',
                          cursor: 'pointer'
                        }}
                        onFocus={(e) => e.target.style.borderColor = 'var(--border-input-focus)'}
                        onBlur={(e) => e.target.style.borderColor = 'var(--border-input)'}
                      >
                        <option value="">Sélectionnez un type de consultation</option>
                        {siteData.consultations.map((consultation, index) => (
                          <option key={index} value={consultation}>
                            {consultation}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        marginBottom: '0.5rem',
                        fontSize: '0.95rem',
                        fontWeight: 500,
                        color: 'var(--text-primary)'
                      }}>
                        <Calendar size={18} />
                        Date souhaitée *
                      </label>
                      <input
                        type="date"
                        name="preferredDate"
                        value={formData.preferredDate}
                        onChange={handleChange}
                        required
                        min={new Date().toISOString().split('T')[0]}
                        style={{
                          width: '100%',
                          padding: '0.875rem 1rem',
                          border: '1px solid var(--border-input)',
                          borderRadius: '0.5rem',
                          fontSize: '1rem',
                          transition: 'all 0.2s ease',
                          background: 'white'
                        }}
                        onFocus={(e) => e.target.style.borderColor = 'var(--border-input-focus)'}
                        onBlur={(e) => e.target.style.borderColor = 'var(--border-input)'}
                      />
                    </div>

                    <div>
                      <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        marginBottom: '0.5rem',
                        fontSize: '0.95rem',
                        fontWeight: 500,
                        color: 'var(--text-primary)'
                      }}>
                        <Clock size={18} />
                        Heure souhaitée *
                      </label>
                      <select
                        name="preferredTime"
                        value={formData.preferredTime}
                        onChange={handleChange}
                        required
                        style={{
                          width: '100%',
                          padding: '0.875rem 1rem',
                          border: '1px solid var(--border-input)',
                          borderRadius: '0.5rem',
                          fontSize: '1rem',
                          transition: 'all 0.2s ease',
                          background: 'white',
                          cursor: 'pointer'
                        }}
                        onFocus={(e) => e.target.style.borderColor = 'var(--border-input-focus)'}
                        onBlur={(e) => e.target.style.borderColor = 'var(--border-input)'}
                      >
                        <option value="">Sélectionnez une heure</option>
                        <option value="08:00">08:00</option>
                        <option value="09:00">09:00</option>
                        <option value="10:00">10:00</option>
                        <option value="11:00">11:00</option>
                        <option value="13:00">13:00</option>
                        <option value="14:00">14:00</option>
                        <option value="15:00">15:00</option>
                        <option value="16:00">16:00</option>
                        <option value="17:00">17:00</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Message */}
                <div style={{ marginBottom: '2rem' }}>
                  <label style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    marginBottom: '0.5rem',
                    fontSize: '0.95rem',
                    fontWeight: 500,
                    color: 'var(--text-primary)'
                  }}>
                    <MessageSquare size={18} />
                    Message (optionnel)
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={4}
                    placeholder="Parlez-nous de votre situation, vos objectifs ou vos questions..."
                    style={{
                      width: '100%',
                      padding: '0.875rem 1rem',
                      border: '1px solid var(--border-input)',
                      borderRadius: '0.5rem',
                      fontSize: '1rem',
                      transition: 'all 0.2s ease',
                      background: 'white',
                      fontFamily: 'inherit',
                      resize: 'vertical'
                    }}
                    onFocus={(e) => e.target.style.borderColor = 'var(--border-input-focus)'}
                    onBlur={(e) => e.target.style.borderColor = 'var(--border-input)'}
                  />
                </div>

                {/* Submit Button */}
                <button type="submit" className="btn-primary" style={{ width: '100%' }}>
                  Confirmer le rendez-vous
                  <CheckCircle2 size={20} />
                </button>

                <p className="body-small" style={{ textAlign: 'center', marginTop: '1rem' }}>
                  * Champs obligatoires
                </p>
              </form>
            ) : (
              <div style={{
                textAlign: 'center',
                padding: '3rem 1rem'
              }}>
                <div style={{
                  width: '5rem',
                  height: '5rem',
                  borderRadius: '50%',
                  background: 'var(--accent-primary-light)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 2rem',
                  color: 'var(--accent-primary)'
                }}>
                  <CheckCircle2 size={48} />
                </div>
                <h3 className="heading-2" style={{ marginBottom: '1rem', color: 'var(--accent-primary)' }}>
                  Demande envoyée !
                </h3>
                <p className="body-large">
                  Nous avons bien reçu votre demande de rendez-vous.<br />
                  Notre équipe vous contactera rapidement pour confirmer.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="section" style={{ background: 'var(--bg-page)' }}>
        <div className="container" style={{ maxWidth: '900px' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '2rem'
          }}>
            <div style={{
              background: 'white',
              borderRadius: '1rem',
              padding: '2rem',
              border: '1px solid var(--border-light)',
              textAlign: 'center'
            }}>
              <Clock size={32} style={{ color: 'var(--accent-primary)', margin: '0 auto 1rem' }} />
              <h4 className="heading-3" style={{ marginBottom: '0.75rem' }}>
                Réponse rapide
              </h4>
              <p className="body-medium">
                Nous vous recontactons sous 24h pour confirmer votre rendez-vous
              </p>
            </div>

            <div style={{
              background: 'white',
              borderRadius: '1rem',
              padding: '2rem',
              border: '1px solid var(--border-light)',
              textAlign: 'center'
            }}>
              <Calendar size={32} style={{ color: 'var(--accent-primary)', margin: '0 auto 1rem' }} />
              <h4 className="heading-3" style={{ marginBottom: '0.75rem' }}>
                Flexibilité
              </h4>
              <p className="body-medium">
                Nous adaptons nos horaires selon vos disponibilités
              </p>
            </div>

            <div style={{
              background: 'white',
              borderRadius: '1rem',
              padding: '2rem',
              border: '1px solid var(--border-light)',
              textAlign: 'center'
            }}>
              <CheckCircle2 size={32} style={{ color: 'var(--accent-primary)', margin: '0 auto 1rem' }} />
              <h4 className="heading-3" style={{ marginBottom: '0.75rem' }}>
                Simple & Rapide
              </h4>
              <p className="body-medium">
                Réservez en quelques clics, sans complications
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RendezVousPage;
